import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";

const PublicRoute = ({ contract }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      window.location.assign("/");
    }
  }, [user]);

  return <Outlet />;
};

export default PublicRoute;
